import React from 'react';

const Services = () => {
  return (
    <section id="services" className="section-padding">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title lang-en">Our Services</h2>
          <h2 className="section-title lang-ar" style={{ display: 'none' }}>خدماتنا</h2>
          <div className="shape wow fadeInDown"></div>
          <p className="section-subtitle lang-en" style={{ marginTop: '12px', color: '#777' }}>
            Cloud-based SaaS for office refreshment management - subdomains, points, real-time kitchen orders.
          </p>
          <p className="section-subtitle lang-ar" style={{ display: 'none', marginTop: '12px', color: '#777' }}>
            نظام SaaS سحابي لإدارة المشروبات بالمكاتب - نطاقات فرعية، نقاط، وطلبات المطبخ في الوقت الحقيقي.
          </p>
        </div>

        <div className="row">
          {/* Service 1 */}
          <div className="col-md-6 col-lg-4 col-xs-12">
            <div className="services-item">
              <div className="icon"><i className="lni-world"></i></div>
              <div className="services-content">
                <h3>
                  <a href="#" className="lang-en">Company Subdomains</a>
                  <a href="#" className="lang-ar" style={{ display: 'none' }}>نطاقات فرعية للشركات</a>
                </h3>
                <p className="lang-en">Each company gets its own subdomain and isolated workspace for users, settings and reports.</p>
                <p className="lang-ar" style={{ display: 'none' }}>كل شركة تحصل على نطاق فرعي ومساحة عمل منفصلة للإعدادات، المستخدمين والتقارير.</p>
              </div>
            </div>
          </div>

          {/* Service 2 */}
          <div className="col-md-6 col-lg-4 col-xs-12">
            <div className="services-item">
              <div className="icon"><i className="lni-coffee-cup"></i></div>
              <div className="services-content">
                <h3>
                  <a href="#" className="lang-en">Employee Ordering</a>
                  <a href="#" className="lang-ar" style={{ display: 'none' }}>طلبات الموظفين</a>
                </h3>
                <p className="lang-en">Employees order drinks using points or cash; personal favorites and custom drinks supported.</p>
                <p className="lang-ar" style={{ display: 'none' }}>الموظفون يطلبون مشروبات بالنقاط أو بالفلوس؛ يدعم المفضلات والمشروبات المخصصة.</p>
              </div>
            </div>
          </div>

          {/* Service 3 */}
          <div className="col-md-6 col-lg-4 col-xs-12">
            <div className="services-item">
              <div className="icon"><i className="lni-reload"></i></div>
              <div className="services-content">
                <h3>
                  <a href="#" className="lang-en">Real-time Kitchen</a>
                  <a href="#" className="lang-ar" style={{ display: 'none' }}>عرض المطبخ في الوقت الحقيقي</a>
                </h3>
                <p className="lang-en">A separate kitchen subdomain shows incoming orders live so staff can prepare them immediately.</p>
                <p className="lang-ar" style={{ display: 'none' }}>نطاق فرعي للمطبخ يعرض الطلبات الواردة مباشرة ليتم تجهيزها فوراً.</p>
              </div>
            </div>
          </div>

          {/* Service 4 */}
          <div className="col-md-6 col-lg-4 col-xs-12">
            <div className="services-item">
              <div className="icon"><i className="lni-package"></i></div>
              <div className="services-content">
                <h3>
                  <a href="#" className="lang-en">Inventory & Admin</a>
                  <a href="#" className="lang-ar" style={{ display: 'none' }}>إدارة المخزون والإدارة</a>
                </h3>
                <p className="lang-en">Admins manage stock, ingredients, storage units, assign private employee stock, and view reports.</p>
                <p className="lang-ar" style={{ display: 'none' }}>المدير يدير المخزون، المكونات، وحدات التخزين، يخصّص مخزون خاص للموظفين ويعرض التقارير.</p>
              </div>
            </div>
          </div>

          {/* Service 5 */}
          <div className="col-md-6 col-lg-4 col-xs-12">
            <div className="services-item">
              <div className="icon"><i className="lni-calendar"></i></div>
              <div className="services-content">
                <h3>
                  <a href="#" className="lang-en">Schedules & Favorites</a>
                  <a href="#" className="lang-ar" style={{ display: 'none' }}>جداول ومفضلات المشروبات</a>
                </h3>
                <p className="lang-en">Employees create personal drink schedules, add custom recipes, and mark favorites for quick orders.</p>
                <p className="lang-ar" style={{ display: 'none' }}>الموظف ينشئ جدول مشروبات شخصي، يضيف وصفاته، ويضيف المفضلات للطلب السريع.</p>
              </div>
            </div>
          </div>

          {/* Service 6 */}
          <div className="col-md-6 col-lg-4 col-xs-12">
            <div className="services-item">
              <div className="icon"><i className="lni-bubble"></i></div>
              <div className="services-content">
                <h3>
                  <a href="#" className="lang-en">External Orders & Notifications</a>
                  <a href="#" className="lang-ar" style={{ display: 'none' }}>طلبات خارجية وإشعارات</a>
                </h3>
                <p className="lang-en">Handle external supplier orders (supermarkets, restaurants) and send push notifications to staff.</p>
                <p className="lang-ar" style={{ display: 'none' }}>إدارة طلبات خارجية للموردين وإرسال إشعارات (Push) لموظفي الشركة أو لأفراد مُعيّنين.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
